import { MIGRATION_STATE } from "components/datanode/Constants";
import usePermissions from "hooks/usePermissions";
import useMigrationState from "./useMigrationState";
import useRunsWithDataNode from "./useRunsWithDataNode";
const useShowDatanodeMigration = () => {
  const { isPermitted } = usePermissions();
  const canStartDataNode = isPermitted("datanode:start");
  const { data: isDatanodeConfiguredAndUsed } = useRunsWithDataNode({ enabled: canStartDataNode });
  const { currentStep } = useMigrationState({ enabled: canStartDataNode });
  const migrationNeedsFinalization = (currentStep == null ? void 0 : currentStep.state) === MIGRATION_STATE.RESTART_GRAYLOG.key;
  const shouldShowDatanodeMigration = isDatanodeConfiguredAndUsed === false || isDatanodeConfiguredAndUsed === true && migrationNeedsFinalization;
  return {
    isDatanodeConfiguredAndUsed: canStartDataNode && isDatanodeConfiguredAndUsed === true,
    showDatanodeMigration: canStartDataNode && shouldShowDatanodeMigration
  };
};
export default useShowDatanodeMigration;
